module.exports = __webpack_public_path__ + "static/erp-hero-bg-e5b99039a1380fbc8ae51b22c6d7628f.jpg";